var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex h-3em justify-content-center align-items-center user-select-none"},[_c('span',{staticClass:"font-size-sm text-uppercase text-primary"},[_vm._v(_vm._s(_vm.agency.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }